let url;

if (localStorage.getItem("BASE_URL")) {
	url = localStorage.getItem("BASE_URL");
}
else if (process.env.REACT_APP_BASE_URL) {
	url = process.env.REACT_APP_BASE_URL;
}
else if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
//   url = 'http://127.0.0.1:8000';
	url = 'https://bahraman.com';
} else {
	url = 'https://bahraman.com';
}

export const BASE_BLOG_URL = url;
export const BASE_URL = url + '/api';
export const MEDIA_UPLOAD_URL = `${BASE_URL}/admin/medias/`;
export const PAGE_SIZE = 20;
